import md from '@/routes/middlewares';

import AccessGroup from '@/views/admin/management/AccessGroup.vue';
import AccessGroupPage from '@/views/admin/management/AccessGroupPage.vue';
import AccessGroups from '@/views/admin/management/AccessGroups.vue';
import AdminDefaultAnalysesPage from '@/views/admin/management/default-analyses/AdminDefaultAnalysesPage.vue';
import AdminStandardFamilies from '@/views/admin/management/templates-norms/AdminStandardFamilies.vue';
import AdminStandards from '@/views/admin/management/templates-norms/AdminStandards.vue';
import AdminUsersPage from '@/views/admin/management/AdminUsersPage.vue';
import AutomaticSentence from '@/views/admin/management/automaticSentence/AutomaticSentence.vue';
import ComponentTypePage from '@/views/ComponentTypePage.vue';
import Member from '@/views/member/Member.vue';
import MemberPage from '@/views/member/MemberPage.vue';
import NetworkTypePage from '@/views/NetworkTypePage.vue';
import RouterViewPage from '@/views/RouterViewPage.vue';
import StandardFamilyPage from '@/views/admin/management/templates-norms/StandardFamilyPage.vue';
import Contracts from '@/views/admin/management/Contracts.vue';
import MFeatures from '@/views/admin/management/MFeatures.vue';
import CurrentBillingSummary from '@/views/admin/aquassistBilling/billingRegisterComponent/CurrentBillingSummary.vue';

const management = {
    path: 'management',
    component: RouterViewPage,
    children: [
        // ACCESS GROUPS
        {
            path: 'accessGroups',
            name: 'accessGroups',
            component: AccessGroups,
        },
        {
            path: 'accessGroups/:accessGroupId',
            component: AccessGroupPage,
            meta: {
                middlewares: [
                    md.getAccessGroupInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'accessGroup',
                    component: AccessGroup,
                },
            ],
        },
        // MEMBERS
        {
            path: 'users',
            name: 'users',
            component: AdminUsersPage,
        },
        {
            path: 'users/:memberId',
            component: MemberPage,
            redirect: { name: 'user' },
            meta: {
                middlewares: [
                    md.getMemberInfo,
                ],
            },
            children: [
                {
                    path: 'info',
                    name: 'user',
                    component: Member,
                },
            ],
        },
        // AUTOMATIC SENTENCES
        {
            path: 'automaticSentences',
            name: 'automaticSentences',
            component: AutomaticSentence,
        },
        // DEFAULT ANALYSES
        {
            path: 'defaultAnalyses',
            name: 'defaultAnalyses',
            component: AdminDefaultAnalysesPage,
        },
        {
            path: 'defaultAnalyses/networkTypes/:networkTypeId',
            component: NetworkTypePage,
            meta: {
                middlewares: [
                    md.getNetworkTypeInfo,
                ],
            },
            children: [
                {
                    path: 'componentTypes/:componentTypeId',
                    component: ComponentTypePage,
                    redirect: { name: 'analysisTypesForDefaultAnalyses' },
                    meta: {
                        middlewares: [
                            md.getComponentTypeInfo,
                        ],
                    },
                },
            ],
        },
        // STANDARD FAMILIES
        {
            path: 'standardFamilies',
            name: 'standardFamilies',
            component: AdminStandardFamilies,
        },
        {
            path: 'standardFamilies/:standardFamilyId',
            component: StandardFamilyPage,
            redirect: { name: 'standards' },
            meta: {
                middlewares: [
                    md.getStandardFamilyInfo,
                ],
            },
            children: [
                {
                    path: 'standards',
                    name: 'standards',
                    component: AdminStandards,
                },
            ],
        },
        {
            path: 'contracts',
            name: 'contracts',
            component: Contracts,
            meta: {
                middlewares: [
                    md.showContract,
                ],
            },
        },
        {
            path: 'features',
            name: 'mfeatures',
            component: MFeatures,
        },
        {
            path: 'billingRegister',
            name: 'managementBillingRegister',
            component: CurrentBillingSummary,
        },
    ],
};

export default management;
